import React from "react";
import { Link } from 'react-router-dom';
import { TrendingUp, Banknote, Settings, Users, BarChart3, ArrowUpCircle } from 'lucide-react';
import SectionTitle from "../SectionTitle/SectionTitle";

const Services = [
    {
        id: 1,
        icon: TrendingUp,
        title: 'Value Maximization',
        description: 'Benefit from our proven strategies to increase your pharmacy\'s operational efficiency and market value.',
        slug: 'value-maximization'
    },
    {
        id: 2,
        icon: Banknote,
        title: 'Fair Valuation',
        description: 'Receive a competitive, market-based valuation that recognizes your pharmacy\'s true worth and potential.',
        slug: 'fair-valuation'
    },
    {
        id: 3,
        icon: Settings,
        title: 'Operational Support',
        description: 'Access our expert team\'s operational knowledge and industry best practices to enhance performance.',
        slug: 'operational-support'
    },
    {
        id: 4,
        icon: Users,
        title: 'Staff Retention',
        description: 'Maintain your valuable team while providing enhanced career development opportunities.',
        slug: 'staff-retention'
    },
    {
        id: 5,
        icon: BarChart3,
        title: 'Growth Resources',
        description: 'Leverage our capital and expertise to implement new revenue streams and expansion opportunities.',
        slug: 'growth-resources'
    },
    {
        id: 6,
        icon: ArrowUpCircle,
        title: 'Technology Integration',
        description: 'Upgrade your systems with cutting-edge pharmacy management and automation solutions.',
        slug: 'technology-integration'
    }
];

const ServiceSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-12">
                        <SectionTitle title={"For Pharmacies"} subtitle={"Why Partner with Pharmacy Freedom Fund?"} />
                    </div>
                </div>
                <div className="row">
                    {Services.map((service, index) => (
                        <div className="col-lg-4 col-md-6 col-12" key={index}>
                            <div className="service_card">
                                <div className="icon">
                                    <service.icon style={{ marginTop: 20 }} size={60} />
                                </div>
                                <div className="content">
                                    <h2>{service.title}</h2>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;

